import GapGridItem from "./GapGridItem";
import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";
import dayjs from "dayjs";

export default function GapGrid({ row }) {
  const [isSale, setIsSale] = useState(true);
  const [data, setData] = useState({});

  useEffect(() => {
    const type = isSale ? "saleAnalysis" : "forecastAnalysis";
    setData(row[type]);
    // eslint-disable-next-line
  }, [isSale]);

  const handleChange = (event) => {
    setIsSale(event.target.value);
  };

  return (
    <Grid container rowSpacing={2}>
      <Grid size={10}></Grid>
      <Grid size={2}>
        <FormControl fullWidth size="small">
          <InputLabel>Prognose type</InputLabel>
          <Select
            value={isSale}
            label="Prognose type"
            onChange={handleChange}
            sx={{ width: "100%" }}
          >
            <MenuItem value={true}>Verkopen</MenuItem>
            <MenuItem value={false}>Prognose</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid size={12}>
        <GapGridItem
          startDate={dayjs().subtract(1, "day")}
          endDate={data.selloutDate}
        />
        {row.purchasedOrders.length > 0 &&
          row.purchasedOrders.map((item, index) => {
            return (
              <GapGridItem
                key={index}
                title={`Inkooporder #${index + 1}`}
                startDate={item.deliveryDate}
                endDate={item.sellOutDate}
              />
            );
          })}
      </Grid>
    </Grid>
  );
}
